import { useEffect, useReducer, useState } from 'react';

import axios from 'axios';
import { getReducer } from '../../../utils';

import Breadcrumb from '../../layouts/Breadcrumb';
import './css/enrollmentScreen.css';

import CulturePost from './compoment/CulturePost';
import CareerOpportunities from './compoment/CareerOpportunities';

import { useNavigate, useParams } from 'react-router-dom';
import LoadingBox from '../../compoment/LoadingBox';
import MessageBox from '../../compoment/MessageBox';
import Feedback from '../home/compoments/Feedback';
import RecruitmentHelmet from '../../../helmet/UseRecruitmentHelmet';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS_POST':
      return { ...state, posts: action.payload, loading: false };
    case 'FETCH_SUCCESS_VIDEO':
      return { ...state, videos: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const tabs = [
  {
    title: 'VĂN HÓA THÀNH ĐỒNG GROUP',
    link: 'van-hoa-thanh-dong-group',
  },
  {
    title: 'CƠ HỘI NGHỀ NGHIỆP',
    link: 'co-hoi-nghe-nghiep',
  },
];

const EnrollmentScreen = () => {
  const navigate = useNavigate();

  const params = useParams();
  const { slug = null } = params;

  const [pageIndex, setPageIndex] = useState(1);
  const MAX_LIMIT = 10;

  const [{ loading, error, posts, videos }, dispatch] = useReducer(
    getReducer(reducer),
    {
      videos: [],
      posts: [],
      loading: true,
      error: '',
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const resultPost = await axios.get(
          `/post/public/shows?topicSlug=${slug}&page=${pageIndex}&limit=${MAX_LIMIT}`
        );

        dispatch({
          type: 'FETCH_SUCCESS_POST',
          payload: resultPost.data.data,
        });

        const {
          data: { data: sections },
        } = await axios.get('/page-section/public/shows?pageSlug=tuyen-dung');

        const getSectionContent = (type) =>
          sections
            .filter((item) => item.sectionType === type)
            .flatMap((item) => item.content);

        dispatch({
          type: 'FETCH_SUCCESS_VIDEO',
          payload: getSectionContent('recruit'),
        });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: err.message });
      }
    };
    fetchData();
  }, [slug, pageIndex]);

  return (
    <>
      <RecruitmentHelmet />
      <div>
        <Breadcrumb />
        <section className="enrollment-screen mb-md-5">
          <div className="container">
            <div className="bg-gray ">
              <div className="tabs">
                {tabs.map((tab, index) => {
                  const isActive = slug === tab.link;

                  return (
                    <div
                      key={index}
                      className="tab"
                      style={{
                        color: isActive ? 'var(--color-primary)' : undefined,
                        fontWeight: isActive ? '700' : undefined,
                        textAlign: 'center',
                        cursor: 'pointer',
                      }}
                      onClick={() => navigate(`/tuyen-dung/${tab.link}`)}
                    >
                      {tab.title}
                    </div>
                  );
                })}
              </div>
            </div>

            {loading ? (
              <LoadingBox />
            ) : error ? (
              <MessageBox variant="danger">{error}</MessageBox>
            ) : slug === 'co-hoi-nghe-nghiep' ? (
              <CareerOpportunities posts={posts} setPageIndex={setPageIndex} />
            ) : (
              <CulturePost posts={posts} />
            )}
          </div>
        </section>
        <Feedback data={videos} />
      </div>
    </>
  );
};
export default EnrollmentScreen;
